function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_x0020_1"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "none",
  width: 61.95,
  height: 61.95
}), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M16.61 24.92l0.08 12.86c2.03,0.99 11.76,6.59 13.33,6.52 0.91,-0.04 12.01,-5.67 13.29,-6.62l0.05 -13.76c-1.41,-1.19 -12.28,-6.46 -13.77,-6.4 -1.57,0.06 -5.14,2.28 -6.81,3.12 -1.85,0.92 -6.17,2.07 -6.17,4.28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M38.21 8.95c0.98,2.1 6.61,2.75 10.85,9.47 9.85,15.59 -0.78,34.62 -18.97,35.31 1.09,-2.36 3.57,-3.6 3.35,-6.17 -2.07,0.06 -6.03,6.12 -6.41,7.95 1.92,1.54 3.88,4.97 6.61,5.29 0.11,-3.15 -2.41,-2.87 -3.7,-5.37 12.74,-0.31 22.13,-8.78 24.18,-20.03 3.08,-16.94 -12.83,-29 -15.91,-26.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M30.04 6.3c-21.89,0.94 -30.28,23.44 -20.47,38.12 1.52,2.26 8.78,10.26 12.46,9 -0.51,-3.59 -4.81,-0.79 -10.8,-9.65 -2.88,-4.26 -4.74,-10.11 -3.73,-16.51 1.67,-10.57 10.7,-19.01 22.49,-19.14 -0.29,0.42 -5.97,7.43 -2.41,5.84 0.77,-0.35 4.91,-5.94 5.36,-7.01 -0.73,-1.53 -1.72,-2.18 -2.9,-3.47 -1.26,-1.36 -1.66,-2.66 -3.64,-2.19 -0.13,2.11 2.55,2.77 3.64,5.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFD",
  d: "M30.97 30.97l-0.08 10.93c2.34,-0.81 9.66,-3.88 10.77,-5.99l-0.02 -9.87 -10.67 4.93z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FDFDFD",
  points: "18.35,36.41 28.87,42.02 28.96,31 18.41,25.87 "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFD",
  d: "M19.83 24.2c2.11,1.72 4.77,2.61 7.13,3.83 3.46,1.8 3.87,1.42 7.36,-0.85 -10.61,-5.6 -9.65,-5.38 -14.49,-2.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FDFDFD",
  d: "M26.39 20.74l6.7 3.66c2.98,1.4 3.85,2.42 6.87,0.02 -1.57,-1.43 -4.44,-2.31 -6.51,-3.39 -4.46,-2.31 -2.67,-1.97 -7.06,-0.29z"
}));

var SvgBox = function SvgBox(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlSpace: "preserve",
    width: "2em",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 61.95 61.95",
    role: "img",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Box.669d8cbc.svg";
export { ForwardRef as ReactComponent };